export const PROJECT_MEMBER_ROLE_OPTIONS = [
  { value: 'employee', label: 'Сотрудник' },
  { value: 'admin', label: 'Администратор' },
]

export const PROJECT_MEMBER_SEARCH_DEBOUNCE_MS = 400
/** Первая порция в поиске участников (ТЗ: ~20 + lazy-load). */
export const PROJECT_MEMBER_SEARCH_PER_PAGE = 20
/** Сколько видимых (ещё не добавленных) стараемся держать в списке при пустом поиске. */
export const PROJECT_MEMBER_SEARCH_MIN_VISIBLE = 20

export const TASK_TRACKER_NOT_IN_CATALOG_TOOLTIP =
  'Данный пользователь не добавлен в Task Tracker. Если вы добавите его в этот проект сейчас, он автоматически добавится как пользователь Task Tracker и займет одну лицензию Task Tracker.'
